import { baseApi } from '@/api/baseApi';

import type {
  CreateCustomProjectRequest,
  CreateCustomProjectResponse,
  ListCustomProjectsRequest,
  ListCustomProjectsResponse,
} from './types';

const CUSTOM_PROJECTS = '/lead/v1/custom-projects';

const customProjectsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    createCustomProject: build.mutation<CreateCustomProjectResponse, CreateCustomProjectRequest>({
      query: body => ({
        url: `${CUSTOM_PROJECTS}/create`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomProject'],
    }),

    listCustomProjects: build.query<ListCustomProjectsResponse, ListCustomProjectsRequest>({
      query: ({ page, limit, search }) => ({
        url: `${CUSTOM_PROJECTS}/list`,
        params: { page, limit, ...(search ? { search } : {}) },
      }),
      transformResponse: (response: any) => response.data,
      providesTags: ['CustomProject'],
    }),
  }),
});

export const { useCreateCustomProjectMutation, useListCustomProjectsQuery } = customProjectsApi;
